'use strict';

angular.module('app', ['ngAnimate', 'ngTouch', 'ngCookies', 'ui.router', 'cfp.hotkeys', 'pascalprecht.translate', 'tmh.dynamicLocale', 'zeroclipboard']);